import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from '../../../../common/modal/Modal';
import { getDelivery, putCancelateYangoDelivery } from '../../../../../actions';
import YangoCancelationClaimForm from './YangoCancelationClaimForm';

export const YangoCancelationClaimButton = ({
  deliveryId,
  dispatchPutCancelateYangoDelivery,
  dispatchGetDelivery,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const onSubmit = async ({ cancelState }) => {
    const claim = await dispatchPutCancelateYangoDelivery(deliveryId, {
      cancelState,
    });

    if (claim) {
      setShowModal(false);
      dispatchGetDelivery({ deliveryId });
    }
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onShowModal = () => {
    const newModalBody = (
      <YangoCancelationClaimForm
        onCancel={onCancel}
        onSubmit={onSubmit}
        deliveryId={deliveryId}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="warning" onClick={onShowModal}>
        <i className="fa fa-times" /> Cancelar Yango
      </Button>
      <Modal
        show={showModal}
        title="Cancelar Yango"
        body={modalBody}
        size="lg"
        onClickClose={onCancel}
        onClickCancel={onCancel}
      />
    </>
  );
};

YangoCancelationClaimButton.propTypes = {
  deliveryId: PropTypes.number.isRequired,
  dispatchPutCancelateYangoDelivery: PropTypes.func.isRequired,
  dispatchGetDelivery: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutCancelateYangoDelivery: putCancelateYangoDelivery,
  dispatchGetDelivery: getDelivery,
};

export default connect(null, mapDispatchToProps)(YangoCancelationClaimButton);
